import { useEffect } from "react";
import "./App.css";
import "./styles/playbook.css";
import "./styles/insights.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ThankYou from "./pages/ThankYou";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Insights from "./pages/Insights";
import Article from "./pages/Article";
import About from "./pages/About";
import AdminArticles from "./pages/AdminArticles";
import SocialReplyAssistant from "./pages/SocialReplyAssistant";
import AdminStatus from "./pages/AdminStatus";
import NotFound from "./pages/NotFound";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import AccessibilityToolbar from "./components/AccessibilityToolbar";
import { Toaster } from "./components/ui/sonner";

function ScrollManager() {
  // Handle hash scrolling on load
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<Article />} />
          <Route path="/about" element={<About />} />
          <Route path="/admin/articles" element={<AdminArticles />} />
          <Route path="/admin/social" element={<SocialReplyAssistant />} />
          <Route path="/admin/status" element={<AdminStatus />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <AccessibilityToolbar />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
